import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import Piano from '../utils/Piano';
import lang from '../lang.json';
import anime from 'animejs';

const Module6b = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module6b;

    const [display1, setDisplay1] = useState("none");
    const [display2, setDisplay2] = useState("none");
    const [display3, setDisplay3] = useState("none");
    const [display4, setDisplay4] = useState("none");
    const [display5, setDisplay5] = useState("none");
    const [pause1, setPause1] = useState(true);
    const [pause2, setPause2] = useState(true);
    const [pause3, setPause3] = useState(true);
    const [pause4, setPause4] = useState(true);
    const [pause5, setPause5] = useState(true);
    const [reset1, setReset1] = useState(false);
    const [reset2, setReset2] = useState(false);
    const [reset3, setReset3] = useState(false);
    const [reset4, setReset4] = useState(false);
    const [reset5, setReset5] = useState(false);

    const [pause, setPause] = useState(true);

    const [hasStarted, setHasStarted] = useState(false);

    const print = (time, paused) => {
        console.log(time, paused);
    }

    const animCallback = (time, paused) => {
        setPause(paused);
        if (time > 0 && !hasStarted) {
            setHasStarted(true);
        }
        /* page 1 */
        if (time == 0) {
            setReset1(true);
        }
        if (time > 0 && time < 64) {
            setDisplay1("block");
            setPause1(false);
            setReset1(false);
        } else {
            setDisplay1("none");
            setPause1(true);
            setReset1(true);
        }
        if (time == 64) {
            setReset2(true);
        }
        if (time > 64 && time < 99) {
            setDisplay2("block");
            setPause2(false);
            setReset2(false);
        } else {
            setDisplay2("none");
            setPause2(true);
            setReset2(true);
        }
        if (time >= 99 && time < 141) {
            setDisplay3("block");
            setPause3(false);
            setReset3(false);
        } else {
            setDisplay3("none");
            setPause3(true);
            setReset3(true);
        }
        if (time == 141) {
            setReset4(true);
        }
        if (time > 141 && time < 165) {
            setDisplay4("block");
            setPause4(false);
            setReset4(false);
        } else {
            setDisplay4("none");
            setPause4(true);
            setReset4(true);
        }
        if (time >= 165 && time < 223) {
            setDisplay5("block");
            setPause5(false);
            setReset5(false);
        } else {
            setDisplay5("none");
            setPause5(true);
            setReset5(true);
        }
    }

    useEffect(() => {
        let tl = anime.timeline()
        tl.add({
            targets: '#circle1',
            r: 530,
            duration: 2000,
            easing: 'easeInOutQuad',
        }, 0)
            .add({
                targets: '#svg',
                zIndex: -1,
                duration: 1,
            }, 2000)
    }, []);

    return (
        <>

            <img
                style={{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    width: '660px',
                    zIndex: 2
                }}
                src={process.env.PUBLIC_URL + "/assets/images/module6b/back.jpg"}
            />

            <svg viewBox="0 0 660 500"
                style={
                    { zIndex: 20 }}
                id="svg" >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <
                        rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <
                        circle id="circle1"
                        cx="330"
                        cy="260"
                        r="0"
                        fill="black" />
                </mask>
                <
                    rect x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                />
            </svg>

            <Piano
                dirName={"piano6b"}
                numberOfPages={3}
                pageSpeeds={[64, 77, 82]}
                musicName={"module6b"}
                callback={animCallback}
                style={{ position: 'absolute', top: '300px' }}
            />
            {/*Page 1*/}
            <FramePlayer
                dirName="piano6b_1"
                ext="png"
                frameNumber={697}
                fps={11}
                loop={false}
                paused={pause || pause1}
                resetSignal={reset1}
                style={{ position: 'absolute', top: '0px', left: '0px', display: display1, zIndex: 4 }}
            />
            {/*Page 2*/}
            <FramePlayer
                dirName="piano6b_2"
                ext="png"
                frameNumber={418}
                fps={418 / 35}
                loop={false}
                paused={pause || pause2}
                resetSignal={reset2}
                style={{ position: 'absolute', top: '0px', left: '0px', display: display2, zIndex: 4 }}
            />
            {/*Page 3*/}
            <FramePlayer
                dirName="piano6b_3"
                ext="png"
                frameNumber={507}
                fps={507 / 42}
                loop={true}
                paused={pause || pause3}
                resetSignal={reset3}
                style={{ position: 'absolute', top: '0px', left: '0px', display: display3, zIndex: 4 }}
            />

            {/*Page 4*/}
            <FramePlayer
                dirName="piano6b_4"
                ext="png"
                frameNumber={315}
                fps={315 / 24}
                loop={true}
                paused={pause || pause4}
                resetSignal={reset4}
                style={{ position: 'absolute', top: '0px', left: '0px', display: display4, zIndex: 4 }}
            />

            {/*Page 5*/}
            <FramePlayer
                dirName="piano6b_5"
                ext="png"
                frameNumber={672}
                fps={672 / 58}
                loop={true}
                paused={pause || pause5}
                resetSignal={reset5}
                style={{ position: 'absolute', top: '0px', left: '0px', display: display5, zIndex: 4 }}
            />

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className="t1 text"
                style={{
                    position: 'absolute',
                    top: '60px',
                    left: '60px',
                    width: '500px',
                    opacity: 1,
                    zIndex: 3,
                    color: 'white',
                    fontSize: '15px',
                    padding: '5px',
                    display: hasStarted ? 'none' : 'block'
                }}
            >
                {texts.lang30}
            </p>
        </>
    );
}

export default Module6b;
